import Component from "../../lib/component";
import Tracker from "../../lib/tracker";
import {getTrackerOptions} from "../../lib/tracker_helpers";
import {isEmpty} from "../../helpers/object";

export const AnalyticsListenerConfig = {
    componentTypeKey: 'AnalyticsListener',
    baseHtmlClass: 'js--analytics_listener',
    selector: '.js--analytics_listener',

    datasetConfigKey: 'analytics_listener__config',
    trackerOptionsDatasetConfigKey: 'tracker_options',
    analyticsEventsDatasetConfigKey: 'events',
    analyticsParametersDatasetConfigKey: 'analytics_parameters',

    durationBetweenEventHandling: 1000,
};

/**
 * The AnalyticsListener component listens for events on the component element and sends a corresponding analytics event name to a Tracker.
 * The Tracker will handle the event appropriately for the environment (ie. native app, web).
 */
export class AnalyticsListener extends Component {

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: AnalyticsListenerConfig
        });

        this.setDatasetConfig(AnalyticsListenerConfig.datasetConfigKey);
        this.events = this.getAnalyticsEvents();
        this.analyticsParameters = this.getAnalyticsParameters();
        this.trackerOptions = getTrackerOptions(this.getDatasetConfigValue(AnalyticsListenerConfig.trackerOptionsDatasetConfigKey));
        this.tracker = new Tracker(window, document, this.trackerOptions);

        this.handling = {}; // When an event it being handled we temporarily store the state.
        this.setupListeners();
    }

    /**
     * Set up the listeners as prescribed by the `events` object passed in.
     * Each `events` key is a DOM event name. And the value is the event name to send to the Tracker
     * @return {undefined}
     */
    setupListeners() {
        if (!this.events || isEmpty(this.events)) return;
        // Iterate over the object…
        for (const [eventName, trackerEventName] of Object.entries(this.events)) {
            const handler = this.getHandler(eventName, trackerEventName);
            this.element.addEventListener(eventName, handler.bind(this));
        }
    }

    getHandler(eventName, trackerEventName) {
        return ()=>{
            if (this.handling[eventName] === true) return;
            this.handling[eventName] = true;
            this.trackEvent(trackerEventName);
            setTimeout(()=>{ this.handling[eventName] = false }, AnalyticsListenerConfig.durationBetweenEventHandling);
        };
    }


    trackEvent(trackerEventName) {
        if (!this.tracker || !this.tracker.eventTracker) return;
        this.tracker.eventTracker(trackerEventName, this.analyticsParameters);
    }

    getAnalyticsParameters() {
        const parameters = this.getDatasetConfigValue(AnalyticsListenerConfig.analyticsParametersDatasetConfigKey);
        if (!parameters) return;
        return parameters;
    }

    getAnalyticsEvents() {
        const events = this.getDatasetConfigValue(AnalyticsListenerConfig.analyticsEventsDatasetConfigKey);
        if (!events) return;
        return events;
    }

}
